import React from 'react';
import '../index.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Powered by NextCore Technology Hub</p>
      </div>
    </footer>
  );
};

export default Footer;